import { postJson, getJson, requestVoid } from './client';
import { getRedirectUri } from '../config/oauth';
import type { OAuthProvider } from '../config/oauth';

export type SocialLoginResponse = {
  userId: string;
  provider?: OAuthProvider | null;
  gatewayContextToken?: string | null;
  expiresAt?: string | null;
  newUser: boolean;
  roles?: string[];
  email?: string | null;
  nickname?: string | null;
  profileImageUrl?: string | null;
  signupCompletionToken?: string | null;
  signupCompletionExpiresAt?: string | null;
};

export function socialLogin(provider: OAuthProvider, authorizationCode: string, state?: string) {
  return postJson<SocialLoginResponse>('/api/v1/auth/social/login', {
    provider,
    authorizationCode,
    redirectUri: getRedirectUri(),
    state,
  });
}

export function socialLink(provider: OAuthProvider, authorizationCode: string, state?: string) {
  return postJson<{ provider: string; linked: boolean }>('/api/v1/auth/social/link', {
    provider,
    authorizationCode,
    redirectUri: getRedirectUri(),
    state,
  });
}

export function socialUnlink(provider: OAuthProvider) {
  return requestVoid(`/api/v1/auth/social/link/${provider}`, {
    method: 'DELETE',
  });
}

export type LinkedProvider = {
  provider: string;
};

export type LinkedProvidersResponse = {
  providers: LinkedProvider[];
  /** 이메일/비밀번호 로그인 설정 여부 — 구 응답엔 없을 수 있음(부재 시 false 취급). */
  hasEmailCredential?: boolean;
};

export function getLinkedProviders() {
  return getJson<LinkedProvidersResponse>('/api/v1/auth/social/linked');
}
